export default __webpack_public_path__ + "static/media/Miscellaneous01.a0f1d968.jpg";